/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, computed, effect, input, InputSignal, output, OutputEmitterRef, Signal, ViewChild } from '@angular/core';
import { StateResource } from '@common/tech-shared';
import { Resource } from '@ngxp/rest';
import { DialogComponent, DialogContentComponent, DialogFooterComponent, DialogHeaderComponent } from '@ods/system';
import { ButtonWithSpinnerComponent } from '../../button-with-spinner/button-with-spinner.component';
import { ButtonConfig, DecisionContentConfig } from './decision-dialog.model';

@Component({
  selector: 'odc-decision-dialog',
  imports: [DialogComponent, DialogHeaderComponent, DialogContentComponent, DialogFooterComponent, ButtonWithSpinnerComponent],
  templateUrl: './decision-dialog.component.html',
})
export class DecisionDialogComponent {
  public readonly headline: InputSignal<string> = input.required<string>();
  public readonly subHeadline: InputSignal<string> = input.required<string>();
  public readonly content: InputSignal<DecisionContentConfig | undefined> = input<DecisionContentConfig | undefined>();
  public readonly applyButton: InputSignal<ButtonConfig> = input.required<ButtonConfig>();
  public readonly stateResource: InputSignal<StateResource<Resource>> = input.required<StateResource<Resource>>();
  public readonly closeWhen: InputSignal<(stateResource: StateResource<Resource>) => boolean> =
    input.required<(stateResource: StateResource<Resource>) => boolean>();

  public readonly apply: OutputEmitterRef<void> = output<void>();

  @ViewChild(DialogComponent) private readonly dialog!: DialogComponent;

  private readonly shouldClose: Signal<boolean> = computed(() => this.closeWhen()(this.stateResource()));

  constructor() {
    effect(() => {
      if (this.shouldClose()) this.close();
    });
  }

  public open(): void {
    this.dialog.open();
  }

  public close(): void {
    this.dialog.close();
  }
}
